import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function MenuIcon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 1C7.72107 1 1 7.72107 1 16C1 24.2789 7.72107 31 16 31C24.2789 31 31 24.2789 31 16C31 7.72107 24.2789 1 16 1ZM7.42857 12.7857C5.65429 12.7857 4.21429 14.2257 4.21429 16C4.21429 17.7743 5.65429 19.2143 7.42857 19.2143C9.20286 19.2143 10.6429 17.7743 10.6429 16C10.6429 14.2257 9.20286 12.7857 7.42857 12.7857ZM16 12.7857C14.2257 12.7857 12.7857 14.2257 12.7857 16C12.7857 17.7743 14.2257 19.2143 16 19.2143C17.7743 19.2143 19.2143 17.7743 19.2143 16C19.2143 14.2257 17.7743 12.7857 16 12.7857ZM24.5714 12.7857C22.7971 12.7857 21.3571 14.2257 21.3571 16C21.3571 17.7743 22.7971 19.2143 24.5714 19.2143C26.3457 19.2143 27.7857 17.7743 27.7857 16C27.7857 14.2257 26.3457 12.7857 24.5714 12.7857Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
